(function () {
  if (window.__cartDiscountCodeLoaded) return;
  window.__cartDiscountCodeLoaded = true;

  // Empêche les événements 'change'/'input' du champ code promo de remonter
  // jusqu'aux écouteurs natifs <cart-items>/<cart-drawer-items> (mise à jour de quantité),
  // qui interprèteraient le code saisi comme une quantité invalide.
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('[data-cart-discount-input]')) {
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target.closest && event.target.closest('[data-cart-discount-input]')) {
      event.stopPropagation();
    }
  }, true);

  function getWrapper(target) {
    return target.closest('[data-cart-discount-form]');
  }

  function getMessageEl(wrapper) {
    return wrapper ? wrapper.querySelector('[data-cart-discount-message]') : null;
  }

  function showMessage(wrapper, text) {
    var message = getMessageEl(wrapper);
    if (!message) return;
    message.classList.remove('cart-discount-code__message--applied');
    message.textContent = text;
    message.hidden = false;
  }

  function setLoading(wrapper, isLoading) {
    if (!wrapper) return;
    var button = wrapper.querySelector('[data-cart-discount-submit]');
    if (button) {
      button.classList.toggle('loading', isLoading);
      button.disabled = isLoading;
    }
    var input = wrapper.querySelector('[data-cart-discount-input]');
    if (input) input.disabled = isLoading;
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function isInDrawer(wrapper) {
    return !!(wrapper && wrapper.closest('#CartDrawer'));
  }

  function getUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root + 'cart/update.js';
    return '/cart/update.js';
  }

  function updateCart(discountValue, wrapper, appliedCode) {
    var inDrawer = isInDrawer(wrapper);
    var sections = [];
    var mainCartFooter = document.getElementById('main-cart-footer');

    if (inDrawer) {
      sections.push('cart-drawer');
    } else if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push(mainCartFooter.dataset.id);
    }
    sections.push('cart-icon-bubble');

    setLoading(wrapper, true);

    return fetch(getUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: discountValue, sections: sections })
    })
      .then(function (response) { return response.json(); })
      .then(function (state) {
        var applied = true;
        if (appliedCode && state.discount_codes && state.discount_codes.length) {
          applied = state.discount_codes.some(function (dc) {
            return dc.code && dc.code.toLowerCase() === appliedCode.toLowerCase() && dc.applicable;
          });
        } else if (appliedCode) {
          applied = false;
        }

        if (inDrawer && state.sections && state.sections['cart-drawer']) {
          var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
          if (drawerInner) {
            drawerInner.innerHTML = getSectionInnerHTML(state.sections['cart-drawer'], '.drawer__inner');
          }
        } else if (!inDrawer && mainCartFooter && state.sections && state.sections[mainCartFooter.dataset.id]) {
          mainCartFooter.innerHTML = getSectionInnerHTML(state.sections[mainCartFooter.dataset.id], '#main-cart-footer');
        }

        var cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && state.sections && state.sections['cart-icon-bubble']) {
          cartIconBubble.innerHTML = getSectionInnerHTML(state.sections['cart-icon-bubble'], '.shopify-section');
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));

        if (appliedCode && !applied) {
          var scope = inDrawer ? '#CartDrawer' : '#main-cart-footer';
          var newWrapper = document.querySelector(scope + ' [data-cart-discount-form]');
          if (newWrapper) showMessage(newWrapper, "Ce code promo n'est pas valide ou a expir\u00e9.");
        }

        return state;
      })
      .catch(function () {
        showMessage(wrapper, 'Une erreur est survenue. Veuillez r\u00e9essayer.');
      })
      .then(function (result) {
        setLoading(wrapper, false);
        return result;
      });
  }

  function applyDiscount(wrapper) {
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-cart-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) {
      showMessage(wrapper, 'Veuillez saisir un code promo.');
      input.focus();
      return;
    }
    updateCart(code, wrapper, code);
  }

  function removeDiscount(wrapper) {
    if (!wrapper) return;
    updateCart('', wrapper, null);
  }

  document.addEventListener('click', function (event) {
    var submitBtn = event.target.closest('[data-cart-discount-submit]');
    if (submitBtn) {
      event.preventDefault();
      applyDiscount(getWrapper(submitBtn));
      return;
    }
    var removeBtn = event.target.closest('[data-cart-discount-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeDiscount(getWrapper(removeBtn));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-cart-discount-input]');
    if (!input) return;
    event.preventDefault();
    applyDiscount(getWrapper(input));
  });
})();
